import React, { useEffect, useState } from "react";
import doctorTest from "../../../assets/images/icons/Breadcrumbs/doctor.jpg";
import { useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";
import axios from "axios";
import serverConfig from "../../../utilities/serverConfig.json";
import apiConfig from "../../../utilities/apiConfig.json";
import { toast } from "react-toastify";
import DefualtUser from "../../../assets/images/icons/UserProfileDefualt.svg";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
import Send from "../../../assets/images/icons/sendComment.svg";

const ApplyVisitModal = ({ id, doctorId }) => {
    const isLargeScreen = useMediaQuery("(min-width: 992px)");
    const [comments, setComments] = useState();
    const [desc, setDesc] = useState(""); // State to track input value

    const { token, roles } = useSelector((state) => state.user);
    const tokenLocal = localStorage.getItem("token");
    const headers = {
        Authorization: "Bearer " + (token ? token : tokenLocal),
    };
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const getTurnComments = () => {
        axios
            .get(
                serverConfig.server.url +
                apiConfig.api.getAPIs.eventDetail +
                id +
                "/comments",
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    setComments(response.data.data.comments_list);
                } else {
                    if (response.data.code == 404) {
                        navigate("/404");
                    } else if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    useEffect(() => {
        if (id) {
            getTurnComments();
        }
    }, [id]);

    const changeEventStatusAPI = () => {
        setLoading(true);
        axios
            .post(
                serverConfig.server.url + apiConfig.api.addAPIs.addComment,
                {
                    user_id: doctorId,
                    model_id: id,
                    model_name: "event",
                    content: desc, // Correctly use desc state value here
                },
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setDesc(""); // Clear input field after successful submission
                    getTurnComments()
                } else {
                    if (typeof response.data.errors === "string") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error.message);
            });
    };

    return (
        <div
            className="modal fade"
            id="applyVisitModal"
            tabIndex="-1"
            aria-labelledby="applyVisitModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="applyVisitModalLabel">
                            یادداشت‌ها
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="بستن"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="col-lg-12 col-12">
                            <div className="col-12 color-bootstrap-gray-700">
                                {comments && comments.length > 0 ? (
                                    comments.map((comment, index) => (
                                        <div
                                            key={index}
                                            className={`d-flex row border-radius-8 border-gray-400 p-2 background-bootstrap-gray-100 px-12px ${index > 0 ? 'mt-4' : ''}`}
                                        >
                                            <div className="d-flex col-12 px-0 align-items-center border-bottom pb-2">
                                                <img
                                                    width="55"
                                                    height="55"
                                                    className="rounded-pill me-2"
                                                    src={comment?.file || DefualtUser}
                                                    alt="User"
                                                />
                                                <div
                                                    className="d-flex row"
                                                    style={{ height: isLargeScreen ? '55px' : '48px' }}
                                                >
                                                    <span className=" fw-medium fs-14 color-bootstrap-gray-800">
                                                        {comment?.creator_first_name} {comment?.creator_last_name}
                                                    </span>
                                                    <span className="fw-normal fs-12 mt-1 color-bootstrap-gray-600 ">
                                                        {comment?.last_degree}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="fw-normal fs-14 color-bootstrap-gray-800  mt-3">
                                                <span>{comment?.content}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mt-3">
                                                <span className="fw-normal fs-12 color-bootstrap-gray-600">
                                                    {comment?.date}
                                                </span>
                                                <span className="fw-normal fs-12 color-bootstrap-gray-600">{comment?.time}</span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-3">
                                        <span>یادداشتی وجود ندارد</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <img
                                src={Send}
                                alt="Send Icon"
                                className="me-2"
                                onClick={changeEventStatusAPI} // Trigger API call on click
                            />
                            <input
                                type="text"
                                placeholder="اینجا بنویسید ..."
                                className="form-control flex-grow-1"
                                aria-label="Message Input"
                                value={desc} // Bind input value to state
                                onChange={(e) => setDesc(e.target.value)} // Update state on change
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplyVisitModal;
